import { render, staticRenderFns } from "./PointGiveaway.vue?vue&type=template&id=45457f6c&scoped=true"
import script from "./PointGiveaway.vue?vue&type=script&lang=js"
export * from "./PointGiveaway.vue?vue&type=script&lang=js"
import style0 from "./PointGiveaway.vue?vue&type=style&index=0&id=45457f6c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45457f6c",
  null
  
)

export default component.exports